'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthNull = exports.AuthJWT = exports.AuthHTTP = exports.AuthTMBase = exports.AuthBase = exports.HTTPDataOutletIdProperty = exports.HTTPDataPatronIdProperty = exports.JWTDataTokenProperty = exports.JWTTokenExpiration = exports.JWTOutletNumber = exports.JWTPatronNumber = exports.authTypeNULL = exports.authTypeJWT = exports.authTypeHTTP = exports.storageValueSeparator = exports.storagePropertySeparator = exports.storagePropertyToken = exports.storagePropertyOutletId = exports.storagePropertyPatronId = exports.storagePropertyType = exports.storageKey = exports.StorageObject = exports.AuthenticationPayloadRecord = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.isLoggedIn = isLoggedIn;
exports.mergeAuthenticationPayload = mergeAuthenticationPayload;
exports.mergeRequestResponse = mergeRequestResponse;
exports.getLocalStorage = getLocalStorage;
exports.createLocalStorage = createLocalStorage;
exports.isLocalStorageSupported = isLocalStorageSupported;
exports.createStorage = createStorage;
exports.createAndInitStorage = createAndInitStorage;
exports.checkStorageAuthType = checkStorageAuthType;
exports.clearStoragePayload = clearStoragePayload;
exports.setStoragePayload = setStoragePayload;
exports.generateStorageValue = generateStorageValue;
exports.generateStorageProperty = generateStorageProperty;
exports.getStoragePayload = getStoragePayload;
exports.parseStorageValue = parseStorageValue;
exports.parseStorageProperty = parseStorageProperty;
exports.setStoragePayloadForRequest = setStoragePayloadForRequest;
exports.performFetch = performFetch;
exports.parseJWTToken = parseJWTToken;
exports.parseJWTTokenFromData = parseJWTTokenFromData;
exports.retrieveJWTToken = retrieveJWTToken;
exports.refreshJWTToken = refreshJWTToken;
exports.refreshJWTTokenIfExpired = refreshJWTTokenIfExpired;
exports.getJWTAuthHeadersForToken = getJWTAuthHeadersForToken;
exports.generateHTTPToken = generateHTTPToken;
exports.parseHTTPDetailsFromData = parseHTTPDetailsFromData;
exports.retrieveHTTPData = retrieveHTTPData;
exports.getHTTPAuthHeadersForToken = getHTTPAuthHeadersForToken;
exports.initListeners = initListeners;
exports.addListener = addListener;
exports.removeListener = removeListener;
exports.notifyListeners = notifyListeners;
exports.createRequestState = createRequestState;
exports.createAndAddRequestPromise = createAndAddRequestPromise;
exports.performAndClearRequestPromises = performAndClearRequestPromises;
exports.resolveAndClearRequestPromises = resolveAndClearRequestPromises;
exports.rejectAndClearRequestPromises = rejectAndClearRequestPromises;
exports.batchRequest = batchRequest;
exports.createAuthJWT = createAuthJWT;
exports.createAuthHTTP = createAuthHTTP;
exports.createAuthNull = createAuthNull;

var _immutable = require('immutable');

var _exceptions = require('./exceptions');

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
 *********** Polyfill for Base64 on Node ***********
 */

if (global.Buffer) {
  if (typeof btoa === 'undefined') {
    global.btoa = function (str) {
      return new Buffer(str).toString('base64');
    };
  }

  if (typeof atob === 'undefined') {
    global.atob = function (b64Encoded) {
      return new Buffer(b64Encoded, 'base64').toString();
    };
  }
}

/*
 *********** Authentication state related code ***********
 */

/* Immutable authentication record used to store the authentication payload state */
var AuthenticationPayloadRecord = exports.AuthenticationPayloadRecord = (0, _immutable.Record)({ type: null, patronId: null, outletId: null, token: null });

/* Helper function to create an authentication payload from individual values */
function createAuthenticationPayload(type, patronId, outletId, token) {
  return new AuthenticationPayloadRecord({ type: type, patronId: patronId, outletId: outletId, token: token });
}

function isSet(value) {
  return value !== undefined && value !== null;
}

/* Returns whether the authentication payload is in a state that can be deemed to be loggedIn */
function isLoggedIn(authenticationPayload) {
  if (authenticationPayload) {
    return isSet(authenticationPayload.type) && isSet(authenticationPayload.patronId) && isSet(authenticationPayload.outletId) && isSet(authenticationPayload.token);
  } else {
    return false;
  }
}

/* Merges two authentication payloads, such that if they have the same values, then the same object will be returned */
function mergeAuthenticationPayload(authenticationPayload, newAuthenticationPayload) {
  if (newAuthenticationPayload === null) {
    return newAuthenticationPayload;
  } else if (authenticationPayload === null) {
    return newAuthenticationPayload;
  } else {
    return authenticationPayload.merge(newAuthenticationPayload);
  }
}

/*
 * Helper promise chaining function
 * Merges an authenticationPayload with the result of running a promise-returning request function, and returns the promise
 */
function mergeRequestResponse(authenticationPayload, requestFunction) {
  return requestFunction().then(function (responseAuthenticationPayload) {
    return Promise.resolve(mergeAuthenticationPayload(authenticationPayload, responseAuthenticationPayload));
  }, function (error) {
    return Promise.reject(error);
  });
}

/*
 *********** Storage related code ***********
 */

function getLocalStorage() {
  return localStorage;
}

function createLocalStorage() {
  return new StorageObject();
}

/*
 * Returns a boolean specifying whether or not the browser global localStorage is available for use
 */
function isLocalStorageSupported() {
  var item = 'localStoragePollyfill';
  try {
    var storage = getLocalStorage();
    storage.setItem(item, item);
    storage.removeItem(item);
    return true;
  } catch (e) {
    return false;
  }
}

/*
 * Memory based storage class which can be used as a drop-in replacement for the browser localStorage
 */

var StorageObject = exports.StorageObject = function () {
  function StorageObject() {
    _classCallCheck(this, StorageObject);

    this._data = {};
  }

  _createClass(StorageObject, [{
    key: 'setItem',
    value: function setItem(id, val) {
      return this._data[id] = String(val);
    }
  }, {
    key: 'getItem',
    value: function getItem(id) {
      return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    }
  }, {
    key: 'removeItem',
    value: function removeItem(id) {
      return delete this._data[id];
    }
  }, {
    key: 'clear',
    value: function clear() {
      return this._data = {};
    }
  }]);

  return StorageObject;
}();

/* The key used to store all auth related data in the storage */


var storageKey = exports.storageKey = '_auth';

/* sub-keys to be used to store all parts of the authentication payload/state within the string value in the storage */
var storagePropertyType = exports.storagePropertyType = 'type';
var storagePropertyPatronId = exports.storagePropertyPatronId = 'patronId';
var storagePropertyOutletId = exports.storagePropertyOutletId = 'outletId';
var storagePropertyToken = exports.storagePropertyToken = 'token';

/* the separators to be used when converting the authentication payload/state to/from a string for storage */
var storagePropertySeparator = exports.storagePropertySeparator = ';';
var storageValueSeparator = exports.storageValueSeparator = ':';

/* the supported authentication types
   These are used to detect when the storage has state that is incompatible with the current implementation */
var authTypeHTTP = exports.authTypeHTTP = 'http';
var authTypeJWT = exports.authTypeJWT = 'jwt';
var authTypeNULL = exports.authTypeNULL = 'null';

/*
 * Creates a storage object for use in persisting auth state.
 * The browser's localStorage will be used if available, otherwise a new local/memory Storage will be created
 * If the browser's localStorage is available, an optional callback can be provided that will be run whenever
 * the localStorage is modified by an external browser tab.
*/
function createStorage(externalStorageChangedCallback) {
  if (isLocalStorageSupported()) {
    if (externalStorageChangedCallback) {
      window.addEventListener('storage', function (evt) {
        if (evt.key === storageKey) {
          externalStorageChangedCallback(evt);
        }
      });
    }
    return getLocalStorage();
  } else {
    return createLocalStorage();
  }
}

/*
 * Creates a storage object, and also checks whether the persisted authType is valid
 */
function createAndInitStorage(authType, externalStorageChangedCallback) {
  var storage = createStorage(externalStorageChangedCallback);
  checkStorageAuthType(storage, authType);
  return storage;
}

/*
 * If the provided storage object does not have a persisted authType matching the given authType
 * then the storage will be cleared
 */
function checkStorageAuthType(storage, authType) {
  var storagePayload = getStoragePayload(storage);
  if (storagePayload && storagePayload.type !== authType) {
    console.warn('authType changed: \"' + storagePayload.type + '\" -> \"' + authType + '\"');
    clearStoragePayload(storage);
  }
}

/*
 * Clears all authentication state from the provided storage
 */
function clearStoragePayload(storage) {
  storage.removeItem(storageKey);
}

/*
 * Persists an authentication payload to the storage in string format
 */
function setStoragePayload(storage, authenticationPayload) {
  storage.setItem(storageKey, generateStorageValue(authenticationPayload.toJS()));
}

/*
 * Converts an authentication payload into a string format that can be persisted as a storage value
 */
function generateStorageValue(_ref) {
  var type = _ref.type,
      patronId = _ref.patronId,
      outletId = _ref.outletId,
      token = _ref.token;

  return [generateStorageProperty(storagePropertyType, type), generateStorageProperty(storagePropertyPatronId, patronId), generateStorageProperty(storagePropertyOutletId, outletId), generateStorageProperty(storagePropertyToken, token)].join(storagePropertySeparator);
}

/*
 * Converts a key-value pair into a string that can be persisted as part of a storage value
 */
function generateStorageProperty(storageProperty, storagePropertyValue) {
  return storageProperty + storageValueSeparator + storagePropertyValue;
}

/*
 * Retrieves an authentication payload from the storage in string format and parses it into an authentication payload object
 * If the payload doesn't exist, or has null values, null is returned.
 */
function getStoragePayload(storage) {
  var storageValue = storage.getItem(storageKey);
  if (storageValue) {
    var storagePayload = new AuthenticationPayloadRecord(parseStorageValue(storageValue));
    if (isLoggedIn(storagePayload)) {
      return storagePayload;
    } else {
      return null;
    }
  } else {
    return null;
  }
}

/*
 * Parses a string storage value into an authentication payload object.
 * Any missing payload properties will have their value set to null.
 */
function parseStorageValue(storageValue) {
  var result = {
    type: null, patronId: null, outletId: null, token: null
  };
  var storageProperties = storageValue.split(storagePropertySeparator);
  storageProperties.forEach(function (storageProperty) {
    var propertyAndValue = parseStorageProperty(storageProperty);
    if (propertyAndValue && result[propertyAndValue.property] !== undefined) {
      result[propertyAndValue.property] = propertyAndValue.value;
    }
  });
  return result;
}

/*
 * Parses a key-value pair from a string storage value into a { property, value } object.
 */
function parseStorageProperty(storageProperty) {
  var result = storageProperty.split(storageValueSeparator);
  if (result.length === 2) {
    return { property: result[0], value: result[1] };
  } else {
    return null;
  }
}

/*
 * Helper promise chaining function
 * Updates the storage as appropriate based on a the result of running a promise-returning request function, and returns the promise
 */
function setStoragePayloadForRequest(storage, requestFunction) {
  return requestFunction().then(function (authenticationPayload) {
    setStoragePayload(storage, authenticationPayload);
    return Promise.resolve(authenticationPayload);
  }, function (error) {
    clearStoragePayload(storage);
    return Promise.reject(error);
  });
}

/*
 *********** Fetch related code ***********
 */

/*
 * Returns a promise for fetching json data via the provided arguments, which resolves when the responsestatus code
 * is 200 and the content type header of the response is application/json
 */
function performFetch(fetch, url, options) {
  try {
    return fetch(url, options).then(function (response) {
      if (response.ok) {
        var contentType = response.headers.get('Content-Type', '< unknown >');
        if (!!contentType && contentType.indexOf('application/json') === 0) {
          return response.json();
        } else {
          var reason = 'Bad content type: ' + contentType;
          return Promise.reject(reason);
        }
      } else {
        var _reason = 'Bad status: ' + response.status;
        return Promise.reject(_reason);
      }
    }, function (error) {
      return Promise.reject(error);
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

/*
 *********** JWT auth related code ***********
 */

/* Properties to be parsed from the JWT token's payload */
var JWTPatronNumber = exports.JWTPatronNumber = 'tm-p';
var JWTOutletNumber = exports.JWTOutletNumber = 'tm-o';
var JWTTokenExpiration = exports.JWTTokenExpiration = 'exp';

var JWTDataTokenProperty = exports.JWTDataTokenProperty = 'access_token';

/*
 * Parses the given token and returns an object with properties { patronId, outletId, tokenExpired }
 * If the token parsing fails for any property, their value will be returned as null
 */
function parseJWTToken(token) {
  var patronId = null;
  var outletId = null;
  var tokenExpiration = null;
  var tokenValid = false;
  var tokenError = null;
  var tokenExpired = false;
  var payload = null;
  try {
    payload = JSON.parse(atob(token.split('.')[1]));
    if (!!payload) {
      if (!!payload[JWTPatronNumber]) {
        patronId = payload[JWTPatronNumber];
      }
      if (!!payload[JWTOutletNumber]) {
        outletId = payload[JWTOutletNumber];
      }
      if (!!payload[JWTTokenExpiration]) {
        tokenExpiration = payload[JWTTokenExpiration] * 1000;
        tokenExpired = Date.now() > tokenExpiration;
      }
      tokenValid = patronId !== null && outletId !== null && tokenExpiration !== null;
      if (!tokenValid) {
        tokenError = 'token was missing payload values';
      }
    }
  } catch (error) {
    console.error('Error parsing JWT token: ' + error);
    tokenError = 'token was invalid';
  }
  return { patronId: patronId, outletId: outletId, tokenExpiration: tokenExpiration, tokenValid: tokenValid, tokenExpired: tokenExpired, tokenError: tokenError };
}

/*
 Parses a JWT token from the response returned by the login/refresh fetch requests
 */
function parseJWTTokenFromData(data) {
  if (!!data && !!data[JWTDataTokenProperty]) {
    var token = data[JWTDataTokenProperty];

    var _parseJWTToken = parseJWTToken(token),
        tokenValid = _parseJWTToken.tokenValid,
        tokenError = _parseJWTToken.tokenError,
        patronId = _parseJWTToken.patronId,
        outletId = _parseJWTToken.outletId;

    if (tokenValid === true) {
      return Promise.resolve(createAuthenticationPayload(authTypeJWT, patronId, outletId, token));
    } else {
      var reason = 'Bad JWT Data: ' + tokenError;
      return Promise.reject(reason);
    }
  } else {
    var _reason2 = 'Bad JWT Data: token missing';
    return Promise.reject(_reason2);
  }
}

/*
 * Performs a fetch request to get the JWT authentication payload for the given username and password
 * Returns a promise that when resolved will have the authenticationPayload
 */
function retrieveJWTToken(fetch, url, username, password) {
  var options = {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json'
    },
    'body': JSON.stringify({
      username: username,
      password: password
    })
  };

  return performFetch(fetch, url, options).then(function (data) {
    return parseJWTTokenFromData(data);
  });
}

/*
 * Performs a fetch request to refresh the JWT authentication payload for the given token
 * Returns a promise that when resolved will have the authenticationPayload
 */
function refreshJWTToken(fetch, url, token) {
  var options = {
    'method': 'POST',
    'headers': {
      'Content-Type': 'application/json'
    },
    'body': JSON.stringify({
      token: token
    })
  };

  return performFetch(fetch, url, options).then(function (data) {
    return parseJWTTokenFromData(data);
  });
}

/*
 * Performs a fetch request to refresh the JWT authentication payload for the given token, but only if the token has expired.
 * Returns a promise that when resolved will have the authenticationPayload
 */
function refreshJWTTokenIfExpired(fetch, url, token) {
  var _parseJWTToken2 = parseJWTToken(token),
      tokenValid = _parseJWTToken2.tokenValid,
      tokenError = _parseJWTToken2.tokenError,
      tokenExpired = _parseJWTToken2.tokenExpired,
      patronId = _parseJWTToken2.patronId,
      outletId = _parseJWTToken2.outletId;

  if (tokenValid) {
    if (tokenExpired) {
      return refreshJWTToken(fetch, url, token);
    } else {
      return Promise.resolve(createAuthenticationPayload(authTypeJWT, patronId, outletId, token));
    }
  } else {
    return Promise.reject(tokenError);
  }
}

/*
 Returns the JWT authentication headers for a given JWT token
 */
function getJWTAuthHeadersForToken(token) {
  return {
    'Authorization': 'Bearer ' + token
  };
}

/*
 *********** HTTP auth related code ***********
 */

/* Properties to be parsed from the HTTP auth login response */
var HTTPDataPatronIdProperty = exports.HTTPDataPatronIdProperty = 'patron_number';
var HTTPDataOutletIdProperty = exports.HTTPDataOutletIdProperty = 'outlet_number';

/*
 Returns an HTTP token for the given username and password
 */
function generateHTTPToken(username, password) {
  return btoa(username + ':' + password);
}

/*
 Parses the patronId and outletId from the response returned by the login fetch requests
 */
function parseHTTPDetailsFromData(data, token) {
  if (!!data && !!data[HTTPDataPatronIdProperty] && !!data[HTTPDataOutletIdProperty]) {
    var patronId = data[HTTPDataPatronIdProperty];
    var outletId = data[HTTPDataOutletIdProperty];
    return Promise.resolve(createAuthenticationPayload(authTypeHTTP, patronId, outletId, token));
  } else {
    var reason = 'Bad HTTP Data, user details missing';
    return Promise.reject(reason);
  }
}

/*
 * Performs a fetch request to get the HTTP authentication payload for the given username and password
 * Returns a promise that when resolved will have the authenticationPayload
 */
function retrieveHTTPData(fetch, url, username, password) {
  var token = generateHTTPToken(username, password);
  var options = {
    'headers': getHTTPAuthHeadersForToken(token)
  };

  return performFetch(fetch, url, options).then(function (data) {
    return parseHTTPDetailsFromData(data, token);
  });
}

/*
 Returns the HTTP authentication headers for a given HTTP token
 */
function getHTTPAuthHeadersForToken(token) {
  return {
    'Authorization': 'Basic ' + token
  };
}

/*
 *********** Event listener related code ***********
 */
function initListeners() {
  return [];
}

function addListener(listeners, listener) {
  if (listeners.indexOf(listener) === -1) {
    listeners.push(listener);
  }
}

function removeListener(listeners, listener) {
  var index = listeners.indexOf(listener);
  if (index !== -1) {
    listeners.splice(index, 1);
  }
}

function notifyListeners(listeners) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var listener = _step.value;

      listener();
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}

/*
 *********** Batched request related code ***********
 */

/*
 * Returns the initial request state to allow requests to be batched
 */
function createRequestState() {
  return {
    loading: false,
    requests: []
  };
}

/*
 * Creates and returns a new Promise that can be resolved or rejected via callbacks that are added to the given array
 */
function createAndAddRequestPromise(requests) {
  return new Promise(function (resolve, reject) {
    requests.push({ resolve: resolve, reject: reject });
  });
}

/*
 * Executes the given function (resolve/reject callback) for each of the requests in the provided array, and then clears the array
 */
function performAndClearRequestPromises(requests, performFunction) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = requests[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var request = _step2.value;

      performFunction(request);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  requests.splice(0, requests.length); // clear the requests after they are used
}

/*
 * Resolves all of the promises associated with the given requests array using the provided resolveValue
 */
function resolveAndClearRequestPromises(requests, resolveValue) {
  performAndClearRequestPromises(requests, function (request) {
    return request.resolve(resolveValue);
  });
}

/*
 * Rejects all of the promises associated with the given requests array using the provided rejectValue
 */
function rejectAndClearRequestPromises(requests, rejectValue) {
  performAndClearRequestPromises(requests, function (request) {
    return request.reject(rejectValue);
  });
}

/*
 * Returns a promise that is the result of running the given requestFunction.
 * Uses the provided requestState to tell if a request is already loading
 * If a request is already loading, a batched promise will be returned, that will resolve/reject when the prior request does
 * If a request is not already loading, a new promise will be returned, that resolves/rejects all subsequent promises if present
 */
function batchRequest(requestState, requestFunction) {
  if (requestState.loading === true) {
    return createAndAddRequestPromise(requestState.requests);
  } else {
    requestState.loading = true;
    return requestFunction().then(function (payload) {
      requestState.loading = false;
      resolveAndClearRequestPromises(requestState.requests, payload);
      return Promise.resolve(payload);
    }, function (error) {
      requestState.loading = false;
      rejectAndClearRequestPromises(requestState.requests, error);
      return Promise.reject(error);
    });
  }
}

/*
 *********** Auth interface related code ***********
 */

var AuthBase = exports.AuthBase = function () {
  function AuthBase() {
    _classCallCheck(this, AuthBase);
  }

  _createClass(AuthBase, [{
    key: 'getAuthentication',

    /*
     returns the current authenticationPayload, or null if it does not exists / has been cleared
     */
    value: function getAuthentication() {
      throw new _exceptions.GetAuthenticationNotImplemented('getAuthentication must be implemented');
    }

    /*
     returns a Promise that will resolve with an authenticationPayload when authentication is valid, or reject if invalid
     */

  }, {
    key: 'checkAuthentication',
    value: function checkAuthentication(authenticationPayload) {
      throw new _exceptions.CheckAuthenticationNotImplemented('checkAuthentication must be implemented');
    }

    /*
     returns a Promise that will resolve with an authenticationPayload if the username/password are valid, or reject if invalid
     */

  }, {
    key: 'requestAuthentication',
    value: function requestAuthentication(authenticationPayload, username, password) {
      throw new _exceptions.RequestAuthenticationNotImplemented('requestAuthentication must be implemented');
    }

    /*
     returns a Promise that will resolve if the authentication is successfully cleared, or reject on failure
     */

  }, {
    key: 'clearAuthentication',
    value: function clearAuthentication() {
      throw new _exceptions.ClearAuthenticationNotImplemented('clearAuthentication must be implemented');
    }

    /*
     returns an object with authentication headers that may be used to authenticate fetch requests, typically of the form:
     { 'auth-header': 'auth-header-value' }
     */

  }, {
    key: 'getAuthenticationHeaders',
    value: function getAuthenticationHeaders(authenticationPayload) {
      throw new _exceptions.GetAuthenticationHeadersNotImplemented('getAuthenticationHeaders must be implemented');
    }
  }]);

  return AuthBase;
}();

/*
 * Base Auth class for TheatreManager specific usage
 * Uses localStorage, and supports external storage changed listeners
 */


var AuthTMBase = exports.AuthTMBase = function (_AuthBase) {
  _inherits(AuthTMBase, _AuthBase);

  function AuthTMBase(authType) {
    _classCallCheck(this, AuthTMBase);

    var _this = _possibleConstructorReturn(this, (AuthTMBase.__proto__ || Object.getPrototypeOf(AuthTMBase)).call(this));

    _this._authStorageExternalChanged = _this._authStorageExternalChanged.bind(_this);
    _this._externalAuthenticationListeners = initListeners();
    _this._storage = createAndInitStorage(authType, _this._authStorageExternalChanged);
    return _this;
  }

  _createClass(AuthTMBase, [{
    key: '_authStorageExternalChanged',
    value: function _authStorageExternalChanged(evt) {
      notifyListeners(this._externalAuthenticationListeners);
    }
  }, {
    key: 'addExternalAuthenticationChangedListener',
    value: function addExternalAuthenticationChangedListener(externalAuthenticationListener) {
      addListener(this._externalAuthenticationListeners, externalAuthenticationListener);
    }
  }, {
    key: 'removeExternalAuthenticationChangedListener',
    value: function removeExternalAuthenticationChangedListener(externalAuthenticationListener) {
      removeListener(this._externalAuthenticationListeners, externalAuthenticationListener);
    }
  }, {
    key: 'clearAuthentication',
    value: function clearAuthentication() {
      clearStoragePayload(this._storage);
      return Promise.resolve();
    }
  }, {
    key: 'getAuthentication',
    value: function getAuthentication() {
      return getStoragePayload(this._storage);
    }
  }]);

  return AuthTMBase;
}(AuthBase);

/*
 * HTTP auth class for TheatreManager API usage.
 * Uses localStorage, supports external storage changed listeners, and supports batched login requests.
 */


var AuthHTTP = exports.AuthHTTP = function (_AuthTMBase) {
  _inherits(AuthHTTP, _AuthTMBase);

  function AuthHTTP(requestUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AuthHTTP);

    var _this2 = _possibleConstructorReturn(this, (AuthHTTP.__proto__ || Object.getPrototypeOf(AuthHTTP)).call(this, authTypeHTTP));

    _this2._requestUrl = requestUrl;
    _this2._requestState = createRequestState();

    var _options$fetchCb = options.fetchCb,
        fetchCb = _options$fetchCb === undefined ? fetch : _options$fetchCb;

    _this2._fetchCb = fetchCb;
    return _this2;
  }

  _createClass(AuthHTTP, [{
    key: 'checkAuthentication',
    value: function checkAuthentication(authenticationPayload) {
      if (isLoggedIn(authenticationPayload)) {
        return Promise.resolve(authenticationPayload);
      } else {
        return Promise.reject('not logged in');
      }
    }
  }, {
    key: 'requestAuthentication',
    value: function requestAuthentication(authenticationPayload, username, password) {
      var _this3 = this;

      return batchRequest(this._requestState, function () {
        return mergeRequestResponse(authenticationPayload, function () {
          return setStoragePayloadForRequest(_this3._storage, function () {
            return retrieveHTTPData(_this3._fetchCb, _this3._requestUrl, username, password);
          });
        });
      });
    }
  }, {
    key: 'getAuthenticationHeaders',
    value: function getAuthenticationHeaders(authenticationPayload) {
      return getHTTPAuthHeadersForToken(authenticationPayload.token);
    }
  }]);

  return AuthHTTP;
}(AuthTMBase);

/*
 * JWT auth class for TheatreManager API usage.
 * Uses localStorage, supports external storage changed listeners, and supports batched login & refresh requests.
 */


var AuthJWT = exports.AuthJWT = function (_AuthTMBase2) {
  _inherits(AuthJWT, _AuthTMBase2);

  function AuthJWT(requestUrl, refreshUrl) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, AuthJWT);

    var _this4 = _possibleConstructorReturn(this, (AuthJWT.__proto__ || Object.getPrototypeOf(AuthJWT)).call(this, authTypeJWT));

    _this4._requestUrl = requestUrl;
    _this4._refreshUrl = refreshUrl;
    _this4._requestState = createRequestState();
    _this4._refreshState = createRequestState();

    var _options$fetchCb2 = options.fetchCb,
        fetchCb = _options$fetchCb2 === undefined ? fetch : _options$fetchCb2;

    _this4._fetchCb = fetchCb;
    return _this4;
  }

  _createClass(AuthJWT, [{
    key: 'checkAuthentication',
    value: function checkAuthentication(authenticationPayload) {
      var _this5 = this;

      if (isLoggedIn(authenticationPayload)) {
        var token = authenticationPayload.token;

        return batchRequest(this._refreshState, function () {
          return mergeRequestResponse(authenticationPayload, function () {
            return setStoragePayloadForRequest(_this5._storage, function () {
              return refreshJWTTokenIfExpired(_this5._fetchCb, _this5._refreshUrl, token);
            });
          });
        });
      } else {
        return Promise.reject('not logged in');
      }
    }
  }, {
    key: 'requestAuthentication',
    value: function requestAuthentication(authenticationPayload, username, password) {
      var _this6 = this;

      return batchRequest(this._requestState, function () {
        return mergeRequestResponse(authenticationPayload, function () {
          return setStoragePayloadForRequest(_this6._storage, function () {
            return retrieveJWTToken(_this6._fetchCb, _this6._requestUrl, username, password);
          });
        });
      });
    }
  }, {
    key: 'getAuthenticationHeaders',
    value: function getAuthenticationHeaders(authenticationPayload) {
      return getJWTAuthHeadersForToken(authenticationPayload.token);
    }
  }]);

  return AuthJWT;
}(AuthTMBase);

var nullAuth = new AuthenticationPayloadRecord({ type: authTypeNULL, patronId: null, outletId: null, token: null });

var AuthNull = exports.AuthNull = function (_AuthBase2) {
  _inherits(AuthNull, _AuthBase2);

  function AuthNull() {
    _classCallCheck(this, AuthNull);

    return _possibleConstructorReturn(this, (AuthNull.__proto__ || Object.getPrototypeOf(AuthNull)).apply(this, arguments));
  }

  _createClass(AuthNull, [{
    key: 'getAuthentication',
    value: function getAuthentication() {
      return nullAuth;
    }

    /*
     returns a Promise that will resolve with an authenticationPayload when authentication is valid, or reject if invalid
     */

  }, {
    key: 'checkAuthentication',
    value: function checkAuthentication(authenticationPayload) {
      return Promise.resolve(nullAuth);
    }

    /*
     returns a Promise that will resolve with an authenticationPayload if the username/password are valid, or reject if invalid
     */

  }, {
    key: 'requestAuthentication',
    value: function requestAuthentication(authenticationPayload, username, password) {
      return Promise.resolve(nullAuth);
    }

    /*
     returns a Promise that will resolve if the authentication is successfully cleared, or reject on failure
     */

  }, {
    key: 'clearAuthentication',
    value: function clearAuthentication() {
      return Promise.resolve();
    }

    /*
     returns an object with authentication headers that may be used to authenticate fetch requests, typically of the form:
     { 'auth-header': 'auth-header-value' }
     */

  }, {
    key: 'getAuthenticationHeaders',
    value: function getAuthenticationHeaders(authenticationPayload) {
      return {};
    }
  }]);

  return AuthNull;
}(AuthBase);

function createAuthJWT(requestUrl, refreshUrl, options) {
  return new AuthJWT(requestUrl, refreshUrl, options);
}

function createAuthHTTP(requestUrl, options) {
  return new AuthHTTP(requestUrl, options);
}

function createAuthNull() {
  return new AuthNull();
}